var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGrader = function SvgGrader(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14804_248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7598 3.75293L38.9287 4.00781V7.0957L41.543 8.3418V4.88379C41.543 4.76843 41.6368 4.6748 41.7529 4.6748H44.6797C44.7943 4.6748 44.8887 4.76843 44.8887 4.88379V13.5381L44.8838 13.5801C44.8642 13.6747 44.7804 13.7469 44.6797 13.7471H41.7529C41.6368 13.7471 41.543 13.6534 41.543 13.5381V11.6592H38.9287V14.6807L37.4619 16.8896H37.4141V20.751C39.2737 21.265 40.7749 22.6381 41.4658 24.417L49.1436 22.3613L49.8691 25.0645L47.001 25.8457L46.2549 27.0938L41.6338 28.3311C41.5924 28.4726 41.5463 28.612 41.4951 28.749V31.5215H39.4033C39.2558 31.6305 39.1036 31.7335 38.9463 31.8291H41.2881V37.5137H42.1006V41.0156C42.1186 41.0106 42.1376 41.0078 42.1572 41.0078H45.084C45.2001 41.0078 45.293 41.1016 45.293 41.2178V49.8711C45.293 49.9864 45.2009 50.0811 45.084 50.0811H43.8105V51.1992H45.084C45.2001 51.1992 45.293 51.2928 45.293 51.4082V60.0615C45.293 60.1769 45.2009 60.2705 45.084 60.2705H42.1572C42.1375 60.2705 42.1187 60.2668 42.1006 60.2617V62.6221H40.4385V65.8428H44.6504V70.8926H43.5312V71.2998H42.5957V70.8926H40.6367V71.2998H39.7012V70.8926H37.7422V71.2998H36.8066V70.8926H34.8477V71.2998H33.9121V70.8926H31.9521V71.2998H31.0176V70.8926H29.0596V71.2998H28.123V70.8926H26.9297V65.8428H31.1367V62.6221H29.4727V60.2676C29.4656 60.2683 29.4584 60.2705 29.4512 60.2705H26.5244C26.4083 60.2705 26.3145 60.1769 26.3145 60.0615V51.4082C26.3145 51.2928 26.4083 51.1992 26.5244 51.1992H27.8105V50.0811H26.5244C26.4083 50.0811 26.3145 49.9872 26.3145 49.8711V41.2178C26.3145 41.1024 26.4083 41.0078 26.5244 41.0078H29.4512C29.4583 41.0078 29.4657 41.009 29.4727 41.0098V37.5137H30.2871V31.8291H32.6279C32.4711 31.7338 32.3199 31.6302 32.1729 31.5215H30.1445V31.4092L26.8105 32.3037L25.5596 31.5811L22.4326 32.4199L21.707 29.7129L29.7676 27.5518C29.721 27.2484 29.6973 26.9375 29.6973 26.6211C29.6973 23.8205 31.5879 21.4625 34.1621 20.751V16.8896H34.1162L33.8164 16.4365L32.8193 14.9355L32.6504 14.6807V11.6592H30.0664V13.5381C30.0664 13.6527 29.9728 13.7471 29.8574 13.7471H26.9307C26.8145 13.7471 26.7207 13.6534 26.7207 13.5381V4.88379C26.7207 4.76843 26.8145 4.6748 26.9307 4.6748H29.8574C29.972 4.6748 30.0664 4.76843 30.0664 4.88379V8.23535L32.6504 7.10742V4.00781L32.8203 3.75293L33.915 2.10449H37.6641L38.7598 3.75293Z",
    stroke: "#BDBDBD",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_14804_248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.0538 -60.9443H-497.92V169.997H84.0538V-60.9443Z",
    stroke: "black",
    strokeWidth: 3.59636
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1895 11.1559H41.5384V9.04622L38.2418 7.47461H33.5634L30.2274 8.93164L30.1895 11.1559Z",
    fill: "#C68106",
    stroke: "black",
    strokeWidth: 1.18157
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.143 13.6264C30.143 13.741 30.0493 13.8355 29.9339 13.8355H27.0067C26.8906 13.8355 26.7969 13.7418 26.7969 13.6264V4.97172C26.7969 4.85637 26.8906 4.7627 27.0067 4.7627H29.9339C30.0485 4.7627 30.143 4.85637 30.143 4.97172V13.6264Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9644 13.6264C44.9644 13.741 44.8708 13.8355 44.7554 13.8355H41.8289C41.7128 13.8355 41.6191 13.7418 41.6191 13.6264V4.97172C41.6191 4.85637 41.7128 4.7627 41.8289 4.7627H44.7562C44.8708 4.7627 44.9652 4.85637 44.9652 4.97172V13.6264H44.9644Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7367 49.9599C29.7367 50.0753 29.643 50.1697 29.5277 50.1697H26.6004C26.4843 50.1697 26.3906 50.0761 26.3906 49.9599V41.306C26.3906 41.1906 26.4843 41.0962 26.6004 41.0962H29.5277C29.6422 41.0962 29.7367 41.1899 29.7367 41.306V49.9599Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3695 49.9599C45.3695 50.0753 45.2774 50.1697 45.1605 50.1697H42.2332C42.1171 50.1697 42.0234 50.0761 42.0234 49.9599V41.306C42.0234 41.1906 42.1171 41.0962 42.2332 41.0962H45.1605C45.2766 41.0962 45.3695 41.1899 45.3695 41.306V49.9599Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7367 60.1501C29.7367 60.2654 29.643 60.3591 29.5277 60.3591H26.6004C26.4843 60.3591 26.3906 60.2654 26.3906 60.1501V51.4961C26.3906 51.3808 26.4843 51.2871 26.6004 51.2871H29.5277C29.6422 51.2871 29.7367 51.3808 29.7367 51.4961V60.1501Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3695 60.1501C45.3695 60.2654 45.2774 60.3591 45.1605 60.3591H42.2332C42.1171 60.3591 42.0234 60.2654 42.0234 60.1501V51.4961C42.0234 51.3808 42.1171 51.2871 42.2332 51.2871H45.1605C45.2766 51.2871 45.3695 51.3808 45.3695 51.4961V60.1501Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9942 15.9645L37.9914 14.4633V4.4019L37.197 3.20654H34.5346L33.7402 4.4019V14.4633L34.7366 15.9645H36.9942Z",
    fill: "#F9BA15",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9516 24.5825L48.6459 23.4429L22.7754 30.375L23.0812 31.5154L25.7498 30.8L27.0001 31.5216L45.803 26.4839L46.5485 25.2375L48.9516 24.5825Z",
    fill: "#F9BA15",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.864 31.9887C38.7801 31.9887 41.144 29.6248 41.144 26.7087C41.144 23.7926 38.7801 21.4287 35.864 21.4287C32.9479 21.4287 30.584 23.7926 30.584 26.7087C30.584 29.6248 32.9479 31.9887 35.864 31.9887Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.6217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0652 25.7119H38.998V31.1026H41.0652V25.7119Z",
    fill: "#C68106",
    stroke: "black",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7956 25.7119H30.7285V31.1026H32.7956V25.7119Z",
    fill: "#C68106",
    stroke: "black",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4907 7.25H34.2383V33.835H37.4907V7.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7034 61.1602H32.0234V67.7965H39.7034V61.1602Z",
    fill: "#C68106",
    stroke: "black",
    strokeWidth: 1.6217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5871 38.1924H30.1406V62.1196H41.5871V38.1924Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.18157
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5532 32.7275H31.1738V43.8047H40.5532V32.7275Z",
    fill: "#F9BA15",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3694 43.8789H32.2793V61.7496H39.3694V43.8789Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7479 42.2236H27.8867V58.9245H29.7479V42.2236Z",
    fill: "#F9BA15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8869 42.2236H42.0273V58.9245H43.8869V42.2236Z",
    fill: "#F9BA15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9157 66.7412H27.8164V70.1693H43.9157V66.7412Z",
    fill: "#F9BA15",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1353 70.252H28.1992V71.3885H29.1353V70.252Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6079 70.252H42.6719V71.3885H43.6079V70.252Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7133 70.252H39.7773V71.3885H40.7133V70.252Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8188 70.252H36.8828V71.3885H37.8188V70.252Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0282 70.252H31.0938V71.3885H32.0282V70.252Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9243 70.252H33.9883V71.3885H34.9243V70.252Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14804_248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0 0.506348)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_14804_248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.7419,
    height: 72,
    fill: "white",
    transform: "translate(20.0762 0.506348)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGrader);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "grader.9687223a46affc7b65ee3db1742f703a.svg";